const styles = {
  container: {
    backgroundColor: '#fff !important',
    borderRadius: '.25rem !important',
    border: 'none !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05) !important',
    justifyContent: 'space-between !important',
    margin: '1rem -1rem !important',
    padding: '.4rem !important',
  },
  label: {
    color: '#999 !important',
    fontSize: '.625rem !important',
    fontWeight: 'bold !important',
    letterSpacing: '.125rem !important',
    lineHeight: '.625rem !important',
    textTransform: 'uppercase !important',
    marginBottom: '.625rem !important',
  },
  value: {
    color: '#683caf !important',
    fontSize: '1.875rem !important',
    marginTop: '.625rem !important',

    '& span': {
      fontWeight: '500 !important',
    },
  },
};

export default styles;
